import { render, staticRenderFns } from "./HeroList.vue?vue&type=template&id=4b1ef37b&"
import script from "./HeroList.vue?vue&type=script&lang=js&"
export * from "./HeroList.vue?vue&type=script&lang=js&"
import style0 from "./HeroList.vue?vue&type=style&index=0&id=4b1ef37b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports